export default "__VITE_ASSET__7aac6ce2__"